const CDN_STATIC_URL = process.env.REACT_APP_CDN_STATIC_URL

export const CDN_STATIC_FAQ_BABI_URL = `${CDN_STATIC_URL}/faq-babi`
export const HELP_CENTER_API_PATH = 'app-pf/help-center/v1'
